var F={50:"#EFF1FA",100:"#EFF1FA",200:"#DFE2F6",300:"#AEB7E8",400:"#7585D8",500:"#5d6fd1",600:"#4F5EB2",700:"#414E92",800:"#2F3868"};export{F as default};
